import React, { useState } from 'react';

const TokenIcon = ({ token, size = 32, className }) => {
  const [imageError, setImageError] = useState(false);
  const iconStyle = {
    width: `${size}px`,
    height: `${size}px`,
    fontSize: `${size * 0.5}px`,
    borderRadius: '50%',
    background: 'transparent', // transparent background
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: 'none', // remove shadow for cleaner look
    border: 'none', // remove border
    overflow: 'hidden',
  };

  const getTokenImage = (symbol) => {
    try {
      return `/assets/tokens/${symbol.toLowerCase()}.png`;
    } catch (error) {
      return null;
    }
  };

  const tokenImage = getTokenImage(token.symbol);

  if (!imageError && tokenImage) {
    return (
      <div
        className={`token-icon ${className || ''}`}
        style={iconStyle}
      >
        <img
          src={tokenImage}
          alt={token.symbol}
          onError={() => setImageError(true)}
          style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
        />
      </div>
    );
  }

  // Fallback to symbol with gradient background
  const getGradientColor = (symbol) => {
    const colors = {
      TON: 'linear-gradient(135deg, #0088CC, #0055CC)',
      BNB: 'linear-gradient(135deg, #F3BA2F, #E6A527)',
      USDT: 'linear-gradient(135deg, #26A17B, #1A8462)',
      USDC: 'linear-gradient(135deg, #2775CA, #2265B5)',
      default: 'linear-gradient(135deg, #7A8FFF, #5A6FFF)'
    };
    return colors[symbol] || colors.default;
  };

  return (
    <div
      className={`token-icon ${className || ''}`}
      style={{
        ...iconStyle,
        background: getGradientColor(token.symbol),
        color: 'white',
        fontWeight: '600',
      }}
    >
      {token.symbol?.charAt(0)}
    </div>
  );
};

export default TokenIcon; 